import React from "react"
import Header from "../../components/shared/Header/Header"
import style from "../../components/shared/PageStyle.module.css"
import Footer from "../../components/shared/Footer/Footer"
import { UserEditForm } from "./UserEditForm"
import { UserPaymentSection } from "./UserPaymentSection"
import { UserDeleteForm } from "./UserDeleteForm"
import { useBand } from "../../hooks/useBand"
import { Spinner } from "../../components/shared/Spinner"
import { RequestError } from "../../components/shared/RequestError"

interface User {
  id: number
  first_name: string
  last_name: string
  nickname: string
  email: string
  phone_number: string
  avatar_url?: string
  send_notification_emails: boolean
  send_notification_texts: boolean
  send_weekly_digest_emails: boolean
  send_discovery_emails: boolean
  band_id?: number
  has_payment_method?: boolean
  default_payment_method_last_four?: string | null
}

interface UserSettingsPageProps {
  user: User
}

const UserSettingsPage: React.FC<UserSettingsPageProps> = ({ user }) => {
  const {
    status: bandStatus,
    data: bandData,
    error: bandError,
  } = useBand(user.band_id || null, null, "")
  const band = bandData?.band

  return (
    <div className={style.rootElStyle}>
      <Header user={user} />
      <div className="grid grid-cols-12 w-full pb-2 px-4">
        <div className="col-span-12 border-b-4 mt-4 border-black">
          <h1 className="lg:col-span-8 col-span-12 font-bold text-3xl uppercase">
            User Settings
          </h1>
        </div>
        <div className="col-span-12">
          <UserEditForm user={user} band={band} bandStatus={bandStatus} />
          <UserPaymentSection
            userId={user.id}
            hasPaymentMethod={!!user.has_payment_method}
            lastFour={user.default_payment_method_last_four ?? null}
          />
          <h2 className="lg:col-span-8 col-span-12 font-bold border-b mb-4 border-black text-2xl leading-none uppercase mt-10">
            Delete Your Account
          </h2>
          <p className="pb-4">
            This will remove all of your data stored with bandNada, including:
            bands you follow, chats, and user data. Tips will continue to be
            stored for accounting purposes but not displayed publicly.
          </p>
          <UserDeleteForm user={user} />
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default UserSettingsPage
